import React, { Component } from "react";
import BioDetails from "../components/BioDetails";
import Footer from "../components/Footer";
import Header from "../components/Header";


import services from "../services";

class Details extends Component {
  constructor() {
    super();
    this.state = {
      bioPageDetails: [],
      isLoader: true
    };
  }

  componentDidMount() {
    this.getTeacherBiographyDetails();
  }


  getTeacherBiographyDetails = async () => {
    const bioDetails = await services.getApiCall("v2/course/tutorBio/39");
    this.setState(
      {
        bioPageDetails:bioDetails.data.data, 
        isLoader:false
      },
      ()=>console.log(this.state.bioPageDetails, "CONTENT")
      );
  }
  render() {
    const {bioPageDetails} = this.state
    return (
      <div className="Details">
        <Header />
        <BioDetails bioPageDetails={bioPageDetails} />
        <Footer />
      </div>
    );
  }
}

export default Details;
